import React from 'react'
import ReactExport from 'react-export-excel'
import {Button} from 'antd'

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

class ExportExcelSheets extends React.Component {
    constructor(props) {
        super(props)
        this.DEFAULT_FILENAME = 'Sheets'
        this.state = {
            fileName: this.DEFAULT_FILENAME,
            dataset: [],
            columns: []
        }
    }

    componentDidMount() {
        this.setState({
            fileName: this.props.fileName ?? this.DEFAULT_FILENAME,
            columns: this.props.columns ?? [],
            dataset: this.props.dataset ?? [],
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.setState({
                fileName: this.props.fileName ?? this.DEFAULT_FILENAME,
                columns: this.props.columns ?? [],
                dataset: this.props.dataset ?? [],
            })
        }
    }

    render() {
        const getFileName = () => {
            let today = new Date().toISOString().slice(0, 10)
            return this.state.fileName + '_' + today
        }
        const validateDataset = () => {
            if(this.state.dataset) {
                return this.state.dataset.map((item)=>{
                   if(item instanceof Object) {
                       for (const [key, value] of Object.entries(item)) {
                            if(value instanceof Array) {
                                item[key] = value.join(",")
                            }
                       }
                       return item
                   }else{
                       return item
                   }
                })
            }
            return []
        }

        return (
            <ExcelFile
                filename={getFileName()}
                element={
                    <Button type={"primary"} size='middle' style={{verticalAlign: 'middle'}}>
                        Export
                    </Button>
                }
            >
                <ExcelSheet data={validateDataset()} name='data'>
                    {this.state.columns?.map((column) => {
                        return (
                            <ExcelColumn label={column.label} value={column.value} widthPx={column.widthPx}
                                         style={column.style}/>
                        )
                    })}
                </ExcelSheet>
            </ExcelFile>
        )
    }
}

export default ExportExcelSheets
